import { BBox, Point, Polygon } from "geojson";
import { Identifier } from "react-admin";

import { Space } from "./spaces";
import { ColumnsOf } from "../data";
import { Maybe } from "../utility";

interface SiteMeta {
  bbox: Maybe<BBox>;
}

export interface Site {
  id: Identifier;
  name: string;
  type: string;
  space_id: string;
  created_at: string;
  created_by: Identifier;
  map_urls: Maybe<string[]>;
  geo_box: Maybe<Polygon>;
  svg_box?: Maybe<Polygon>;
  address: Maybe<string>;
  tags: Maybe<string[]>;
  meta?: Maybe<SiteMeta>;
  map_scale: Maybe<number>;
  map_units: Maybe<string>;
  location: Maybe<Point>;
  width: Maybe<number>;
  height: Maybe<number>;
  rotation: number;
  spaces: Space;
  zones: { count: number }[];
  zones_count: number;
}

export type SiteRaw = Omit<Site, "location">;

export type SiteInsert = Pick<
  Site,
  "name" | "type" | "space_id" | "tags" | "map_urls" | "geo_box" | "rotation" | "meta"
> & {
  map_file: Maybe<File>;
  width: Maybe<number>;
  height: Maybe<number>;
};
export type SiteUpdate = Partial<SiteInsert>;

export const SITE_COLUMNS: ColumnsOf<Site> = ["*", "zones(count)"];

export const isSite = (item: unknown): item is Site => {
  const site = item as Site;

  return site.geo_box !== undefined && site.map_urls !== undefined;
};
